import { Button } from "react-bootstrap";
import { AiOutlinePlus } from "react-icons/ai";
import * as S from "./styles";

interface IProps {
  setState?: any;
  label: string;
  state: any;
  onClick: any;
  type: "string" | "number" | "date" | "text";
  autoComplete?: "on" | "off";
  placeholder?: string;
  maxLength?: number;
  isInvalid?: boolean;
  disabled?: boolean;
  onChenge?: any;
  isLoading?: boolean;
}

export default function InputCode({
  label,
  type,
  state,
  autoComplete,
  onClick,
  placeholder,
  maxLength,
  isInvalid,
  disabled,
  setState,
  onChenge,
}: IProps) {
  // Handler padrão caso nenhum onChange seja fornecido
  const handleChange = (e: any) => {
    if (setState) {
      setState(e.target.value);
    } else if (onChenge) {
      onChenge(e);
    }
  };

  return (
    <label>
      <div className="label">{label}</div>
      <S.Wrapper>
        <S.Group>
          <S.FormInput
            type={type}
            autoComplete={autoComplete}
            value={state}
            placeholder={placeholder}
            maxLength={maxLength}
            isInvalid={isInvalid}
            disabled={disabled}
            onChange={handleChange}
            data-invalid={isInvalid ? 'true' : undefined}
            aria-invalid={isInvalid ? 'true' : undefined}
          />
          <Button onClick={onClick} disabled={disabled} size="sm">
            <AiOutlinePlus size={10} />
          </Button>
        </S.Group>
      </S.Wrapper>
    </label>
  );
}